
import BannerLeftCn from './images/banner-left.png';
import BannerRightCn from './images/banner-right.png';
import IllustrationCn1 from './images/img-1.png';
import IllustrationCom1 from './images/img-com-1.png';
import IllustrationCn2 from './images/img-2.png';
import IllustrationCom2 from './images/img-com-2.png';
import IllustrationCn3 from './images/img-3.png';
import IllustrationCom3 from './images/img-com-3.png';
import { ImgSourceMap } from 'globalCommon/utils/index'
import IllustrationCnNew1 from './images/img-new-1.png';
import IllustrationCnNew1Com from './images/img-new-1-en.png';
import atlas from "./images/atlas.png"
import atlasCom from './images/atlas-en.png';



export const IMG_SOURCE: ImgSourceMap = {
    bannerLeft: {
        id: 'ai-technology-m-banner-left',
        src: BannerLeftCn,
    },
    bannerRight: {
        id: 'ai-technology-m-banner-right',
        src: BannerRightCn,
    },
    illustration1: {
        id: 'ai-technology-m-illustration1',
        src: IllustrationCn1,
        srcCom: IllustrationCom1,
    },
    illustration2: {
        id: 'ai-technology-m-illustration2',
        src: IllustrationCn2,
        srcCom: IllustrationCom2,
    },
    illustration3: {
        id: 'ai-technology-m-illustration3',
        src: IllustrationCn3,
        srcCom: IllustrationCom3,
    },
    IllustrationCnNew1: {
        id: 'ai-technology-m-illustrationNew1',
        src: IllustrationCnNew1,
        srcEn: IllustrationCnNew1Com,
        srcCom: IllustrationCnNew1Com,
    },
    atlas: {
        id: 'ai-technology-m-atlas',
        src: atlas,
        srcEn: atlasCom,
        srcCom: atlasCom,
    },
};